var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMember)?_c('member',{attrs:{"swipeClick":_vm.swipeClick,"toBuy":_vm.toBuy}}):_c('visitor',{attrs:{"swipeClick":_vm.swipeClick,"toBuy":_vm.toBuy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }